<form [formGroup]="formGroup">
    <nuc-form-field label="Name">
        <nuc-input formControlName="name" placeholder="Enter name of the package rule" required></nuc-input>
    </nuc-form-field>
</form>
